import React, { useEffect, useState } from 'react';

import cn from 'classnames';

import styles from './CookieBanner.module.scss';

export function CookieBanner() {
  const [isOpen, setIsOpen] = useState(false);
  const [isExist, setExist] = useState(true);

  const handleCLoseButtonClick = () => {
    setIsOpen(false);
    document.documentElement.style.removeProperty('--cookie-banner-showed');
    localStorage.setItem('cookieBanner_closed', 'true');
  };
  useEffect(() => {
    if (!isExist) {
      const id = setTimeout(() => {
        setIsOpen(false);
        localStorage.setItem('cookieBanner_closed', 'true');
        document.documentElement.style.removeProperty('--cookie-banner-showed');
        document.documentElement.style.removeProperty('--footer-bottom-padding');
      }, 10000);
      document.documentElement.style.setProperty('--cookie-banner-showed', `1`);
      document.documentElement.style.setProperty('--footer-bottom-padding', `88px`);

      return () => {
        clearTimeout(id);
      };
    }
  }, [isExist]);

  useEffect(() => {
    if (!localStorage.getItem('cookieBanner_closed')) {
      setExist(false);
      if (!isOpen) setIsOpen(true);
    }
  }, [isOpen]);

  return (
    <div
      className={cn({
        [styles.wrapper]: true,
        [styles.open]: !isExist && isOpen,
        [styles.closed]: !isExist && !isOpen,
      })}
    >
      <div className={styles.content}>
        <p>
          Мы используем{' '}
          <a href="/privacy/#rec748128838" target="_blank">
            файлы cookie
          </a>
          , чтобы сделать сайт лучше.
        </p>
        <button className={styles.button} type="button" onClick={handleCLoseButtonClick}>
          Хорошо
        </button>
      </div>
    </div>
  );
}
